import script from "./ManagePapers.vue?vue&type=script&setup=true&lang=js"
export * from "./ManagePapers.vue?vue&type=script&setup=true&lang=js"

import "./ManagePapers.vue?vue&type=style&index=0&id=7cbc59d5&lang=scss"

const __exports__ = script;

export default __exports__